import React, { Component } from "react";
import { BoxDanger, MnemoCallout, MnemoLoading, ModalHandler, SupportoTecnico, Title } from "components/misc";
import { Button, Container, Col, Row, Card, CardBody, Icon } from "design-react-kit";
import { dateHelper, learningService, networkErrorHelper } from "libs";
import { revisionService } from "libs/api/revisionService";
import { withRouter } from "react-router-dom";
import { MFile, MLabel, MTextArea } from "components/forms";

class ReviewDetailLAC extends Component {
  state = {
    loading: true,
    loadingError: false,
    lessonActivity: "",
    idLessonActivity: 0,
    matricola: "",
    revisionNote: "",
    revisionNoteError: false,
    document: 0,
  };

  componentDidMount() {
    this.pfSignedRef = React.createRef();
    this.convSignedRef = React.createRef();
    const idLessonActivity = parseInt(this.props.match.params.idLessonActivity) > 0 ? this.props.match.params.idLessonActivity : 0;
    this.setState({ idLessonActivity });
    this.loadRemote(idLessonActivity);
  }

  getFile(code) {
    const { lessonActivity } = this.state;
    return lessonActivity.files?.find((f) => f.code === code);
  }

  getMatricola(rCode) {
    learningService
      .getMatricolaStudent(rCode)
      .then(({ data }) => {
        this.setState({ matricola: data.payload.matricola });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  }

  loadRemote(idLessonActivity) {
    revisionService
      .getLessonActivityCompany(idLessonActivity)
      .then(({ data }) => {
        const { user, course, userCourse, lessonActivity } = data.payload;
        const questions = lessonActivity.questions;

        this.getMatricola(userCourse.registrationCode);

        const newState = {
          loading: false,
          user,
          course,
          userCourse,
          lessonActivity,
          document: lessonActivity.id,
        };

        questions.forEach((q) => {
          if (q.field) {
            newState[q.field] = q.answer ?? "";
          }
        });

        this.setState(newState);
      })
      .catch((error) => {
        if (networkErrorHelper.is404(error)) {
        } else {
          networkErrorHelper.notify(error);
          this.setState({
            loadingError: true,
            loading: false,
          });
        }
      });
  }

  goBack() {
    window.history.back();
  }

  handleRevision(status) {
    const { revisionNote } = this.state;

    if (status === "approved") {
      //check if signed docs are uploaded
      const isPfUploaded = this.pfSignedRef.current?.checkValidation();
      const isConvUploaded = this.convSignedRef.current?.checkValidation();
      if (!isPfUploaded || !isConvUploaded) {
        return;
      }
    }

    //if NON IDONEO and missing revisionNote
    if (status === "approvePending" && (!revisionNote || revisionNote.trim() === "")) {
      this.setState({ revisionNoteError: true });
      return;
    }

    //open modal
    const isApprove = status === "approved";
    const title = isApprove ? "Approvazione documentazione" : "Documentazione non idonea";
    const message = isApprove
      ? "Stai per approvare la documentazione. I file controfirmati saranno resi disponibili allo studente. Procedere?"
      : "Stai per inviare una richiesta di modifica della documentazione allo studente. Procedere?";

    ModalHandler.show(null, title, message, null, () => this.confirmRevision(status));
  }

  confirmRevision = (status) => {
    const { idLessonActivity, revisionNote } = this.state;
    const payload = { idLessonActivity, status, revisionNote };
    revisionService
      .updateLessonActivityCompany(payload)
      .then(() => {
        this.goBack();
      })
      .catch((error) => {
        console.error(error);
        networkErrorHelper.notify(error);
      });
  };

  render() {
    const {
      lessonActivity,
      document,
      user,
      userCourse,
      course,
      revisionNote,
      revisionNoteError,
      loading,
      loadingError,
      schoolCode,
      dateEnd,
      isSchoolAccredited,
      schoolName,
      schoolAddress,
      schoolCap,
      schoolCity,
      schoolProvince,
      schoolEmail,
      schoolPec,
      matricola,
    } = this.state;

    const { status } = lessonActivity;

    const progetto = this.getFile("progettoFormativo");
    const convenzione = this.getFile("convenzione");
    const contratto = this.getFile("contrattoLavoro");

    const progettoSigned = this.getFile("progettoFormativo_signed");
    const convenzioneSigned = this.getFile("convenzione_signed");

    return (
      <>
        <section className="my-4">
          {loading ? (
            <MnemoLoading></MnemoLoading>
          ) : loadingError ? (
            <BoxDanger className="m-5">
              Si è verificato un errore durante l'elaborazione della richiesta, se il problema persiste puoi <SupportoTecnico />
            </BoxDanger>
          ) : (
            <Container>
              <Title>Approvazione Documenti Tirocinio Diretto</Title>
              <Col lg={{ size: 12 }} className="text-right">
                <Button onClick={this.goBack} color="btn btn-primary bg-dark m-2 p-3">
                  Torna Indietro
                </Button>
              </Col>

              <Card tag="div" className="card-bg card-big rounded border-bottom-card mb-4">
                <div className="flag-icon" />
                <CardBody>
                  <b>Nome</b>: {user.name}
                  <br />
                  <b>Cognome</b>: {user.surname}
                  <br />
                  <b>Email</b>: {user.email}
                  <br />
                  <b>Codice Registrazione</b>: {userCourse.registrationCode}
                  {matricola && (
                    <>
                      <br />
                      <b>Matricola</b>: {matricola}
                    </>
                  )}
                  <br />
                  <b>Titolo corso</b>: {course.title}
                  <br />
                  <b>Codice corso</b>: {course.code}
                </CardBody>
              </Card>

              {status === "approved" && (
                <Card tag="div" className="card-bg card-big rounded border-bottom-card mb-4">
                  <div className="flag-icon" />
                  <div className="etichetta">
                    <Icon icon="it-user" padding={false} />
                    <span>Documentazione controfirmata caricata</span>
                  </div>
                  <CardBody>
                    <p>
                      <b>Progetto formativo:</b>{" "}
                      {progettoSigned?.fileUrl ? (
                        <a href={`${process.env.REACT_APP_API_URL}${progettoSigned.fileUrl}`} rel="noopener noreferrer" target="_blank">
                          Visualizza file
                        </a>
                      ) : (
                        "File mancante"
                      )}
                    </p>

                    <p>
                      <b>Convenzione:</b>{" "}
                      {convenzioneSigned?.fileUrl ? (
                        <a href={`${process.env.REACT_APP_API_URL}${convenzioneSigned.fileUrl}`} rel="noopener noreferrer" target="_blank">
                          Visualizza file
                        </a>
                      ) : (
                        "File mancante"
                      )}
                    </p>
                  </CardBody>
                </Card>
              )}

              <Card tag="div" className="card-bg card-big rounded border-bottom-card mb-4">
                <div className="flag-icon" />
                <div className="etichetta">
                  <Icon icon="it-user" padding={false} />
                  <span>Documentazione caricata dallo studente</span>
                </div>
                <CardBody>
                  <span className={`badge m-3 p-2 ${status === "toApprove" ? "badge-warning" : "badge-success"}`}>
                    {status === "toApprove" ? "In attesa di approvazione" : "Approvato"}
                  </span>

                  <MnemoCallout className="mnemo-callout-info">
                    <h4 className="mb-3">Dati Istituto</h4>

                    {schoolName && (
                      <p>
                        <b>Denominazione:</b> {schoolName}
                      </p>
                    )}

                    {schoolCode && (
                      <p>
                        <b>Codice meccanografico:</b> {schoolCode}
                      </p>
                    )}

                    {(schoolAddress || schoolCity) && (
                      <p>
                        <b>Sede:</b> {schoolAddress}
                        {schoolCap ? `, ${schoolCap}` : ""} - {schoolCity} ({schoolProvince})
                      </p>
                    )}

                    {schoolEmail && (
                      <p>
                        <b>E-mail:</b> {schoolEmail}
                      </p>
                    )}

                    {schoolPec && (
                      <p>
                        <b>PEC:</b> {schoolPec}
                      </p>
                    )}

                    <hr />

                    {dateEnd && (
                      <p>
                        <b>Data fine tirocinio: </b> {dateHelper.toITDate(dateEnd)}
                      </p>
                    )}

                    <p>
                      <b>Progetto formativo:</b>{" "}
                      {progetto?.fileUrl ? (
                        <a href={`${process.env.REACT_APP_API_URL}${progetto.fileUrl}`} rel="noopener noreferrer" target="_blank">
                          Visualizza file
                        </a>
                      ) : (
                        "File mancante"
                      )}
                    </p>

                    <p>
                      <b>Convenzione:</b>{" "}
                      {convenzione?.fileUrl ? (
                        <a href={`${process.env.REACT_APP_API_URL}${convenzione.fileUrl}`} rel="noopener noreferrer" target="_blank">
                          Visualizza file
                        </a>
                      ) : (
                        "File mancante"
                      )}
                    </p>

                    {isSchoolAccredited === "2" && (
                      <p>
                        <b>Contratto di lavoro:</b>{" "}
                        {contratto?.fileUrl ? (
                          <a href={`${process.env.REACT_APP_API_URL}${contratto.fileUrl}`} rel="noopener noreferrer" target="_blank">
                            Visualizza file
                          </a>
                        ) : (
                          "File mancante"
                        )}
                      </p>
                    )}
                  </MnemoCallout>
                </CardBody>
              </Card>

              {status === "toApprove" && (
                <Card tag="div" className="card-bg card-big rounded border-bottom-card mb-4">
                  <div className="flag-icon" />
                  <div className="etichetta">
                    <Icon icon="it-user" padding={false} />
                    <span>Upload documentazione controfirmata</span>
                  </div>
                  <CardBody>
                    <Row>
                      <Col md="12">
                        <MLabel label="Progetto formativo controfirmato" />
                        <MFile
                          id="progettoFormativoSignedFile"
                          ref={this.pfSignedRef}
                          field="document"
                          name="document"
                          label="Progetto Formativo Controfirmato"
                          value={document}
                          config={{
                            endPoint: "lesson-activity-file",
                            fieldName: "document",
                            maxFiles: 1,
                            minFiles: 1,
                            accept: ".pdf,.doc,.docx,.p7m,.xml",
                            code: "progettoFormativo_signed",
                            mandatory: true,
                          }}
                        />
                      </Col>
                      <Col md="12">
                        <MLabel label="Convenzione controfirmata" />
                        <MFile
                          id="convenzioneSignedFile"
                          ref={this.convSignedRef}
                          field="document"
                          name="document"
                          label="Convenzione Controfirmata"
                          value={document}
                          config={{
                            endPoint: "lesson-activity-file",
                            fieldName: "document",
                            maxFiles: 1,
                            minFiles: 1,
                            accept: ".pdf,.doc,.docx,.p7m,.xml",
                            code: "convenzione_signed",
                            mandatory: true,
                          }}
                        />
                      </Col>
                    </Row>

                    <Row className="my-4 justify-content-end">
                      <Col xs="12" className="mb-3">
                        <MTextArea
                          label="Note revisione per lo studente"
                          rows="5"
                          value={revisionNote}
                          invalid={revisionNoteError}
                          infoText="Le note sono obbligatorie se la documentazione non è valida"
                          onChange={(index, value) =>
                            this.setState({
                              revisionNote: value,
                              revisionNoteError: false,
                            })
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="my-4 justify-content-end">
                      <Col xs="auto">
                        <Button color="primary" className="m-2" onClick={() => this.handleRevision("approved")}>
                          IDONEO
                        </Button>
                      </Col>
                      <Col xs="auto">
                        <Button color="danger" className="m-2" onClick={() => this.handleRevision("approvePending")}>
                          NON IDONEO
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              )}
            </Container>
          )}
        </section>
      </>
    );
  }
}

export default withRouter(ReviewDetailLAC);
